import { InvoiceState } from '../types/invoiceState'

export const invoiceStateToTranslationKey: Record<InvoiceState, string> = {
  draft: 'dashboard.widget.invoices.draft',
  overdue: 'dashboard.widget.invoices.overdue',
  paid: 'dashboard.widget.invoices.paid',
  unpaid: 'dashboard.widget.invoices.unpaid',
}
